// @ts-strict-ignore
import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { escape } from 'lodash-es';

@Injectable()
export class LMSecurityUtilService {

  constructor(private domSanitizer: DomSanitizer) {}

  escape(unsafe: string): string {
    const sanitized = this.domSanitizer.sanitize(SecurityContext.HTML, unsafe);
    return escape(sanitized);
  }
}
